import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useState } from 'react';
import { MdUpdate } from 'react-icons/md';
import { TbCalculator } from 'react-icons/tb';
// import export from '@iconify/icons-ic/export';
// material
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Tooltip,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import useCallCenterSelector from '../../store/Slice/CallCenterList/CallCenterListSelector';
// ----------------------------------------------------------------------

export default function CallCenterToolbar({
  filterName,
  onFilterName,
  parent,
  filterDatesRange,
  setFilterDatesRange,
  selectLoanType,
  setSelectLoanType,
  onFilterLoan,
  selectSource,
  onFilterSource,
  selectStatus,
  setSelectStatus,
  onFilterStatus,
  selected,
  setSelectSource,
  setFilterName
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);

  const { SourceDrop, StatusDrop, LoanTypeData } = useGlobalSelector();

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setSelectSource(' ');
    setSelectStatus(' ');
    setFilterName('');
    setSelectLoanType(' ');
  };

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectSource}`
                }}
                value={selectSource}
                onChange={onFilterSource}
              >
                <MenuItem value=" " disabled>
                  Select Source
                </MenuItem>
                {SourceDrop.length > 0 &&
                  SourceDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectLoanType}`
                }}
                value={selectLoanType}
                onChange={onFilterLoan}
              >
                <MenuItem value=" " disabled>
                  Select Loan Type
                </MenuItem>

                {LoanTypeData?.length > 0 &&
                  LoanTypeData?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectStatus}`
                }}
                value={selectStatus}
                onChange={onFilterStatus}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>
                ?
                {StatusDrop?.length > 0 &&
                  StatusDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid>
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          <Tooltip title="Update" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              classes={{ disabled: 'disabledBtn' }}
              disabled={selected && selected.length < 1}
              onClick={(e) => {
                localStorage.setItem('selectedItem', JSON.stringify(selected));
                navigate(`/${parent}/update`);
              }}
            >
              <MdUpdate size={18} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Recommendation" placement="top" arrow>
            <IconButton
              className="squareIconButton ml-1"
              onClick={(e) => {
                window.open(`http://reco.kalolytic.com/`, `_blank`);
              }}
            >
              <TbCalculator size={18} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Call List"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
